import { render, staticRenderFns } from "./InfoList.vue?vue&type=template&id=0ce2bf89&"
import script from "./InfoList.js?vue&type=script&lang=js&"
export * from "./InfoList.js?vue&type=script&lang=js&"
import style0 from "./InfoList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports